<template>
  <section>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82.167"
      height="95.103"
      viewBox="0 0 82.167 95.103"
    >
      <g id="Group_443" data-name="Group 443" transform="translate(-14.4)">
        <circle
          id="Ellipse_286"
          data-name="Ellipse 286"
          cx="1.908"
          cy="1.908"
          r="1.908"
          transform="translate(18.759 45.253)"
          fill="#89bf4d"
        />
        <circle
          id="Ellipse_287"
          data-name="Ellipse 287"
          cx="1.908"
          cy="1.908"
          r="1.908"
          transform="translate(27.126 60.961)"
          fill="#89bf4d"
        />
        <circle
          id="Ellipse_288"
          data-name="Ellipse 288"
          cx="1.908"
          cy="1.908"
          r="1.908"
          transform="translate(20.667 56.997)"
          fill="#89bf4d"
        />
        <path
          id="Path_637"
          data-name="Path 637"
          d="M345.538,480.363a10.452,10.452,0,0,1-1.1-4.135c-.253-2.527-.09-6.786,2.119-12.727a25.665,25.665,0,0,0-1.017-20.427l.254-.147a22.539,22.539,0,0,1,2.127,6.025,26.286,26.286,0,0,1-1.089,14.651c-4.177,11.236-1.072,16.555-1.04,16.607Z"
          transform="translate(-322.353 -394.37)"
          fill="#cfcce0"
        />
        <path
          id="Path_638"
          data-name="Path 638"
          d="M325.87,410.254a2.055,2.055,0,1,1,2.055-2.055A2.055,2.055,0,0,1,325.87,410.254Zm0-3.817a1.762,1.762,0,1,0,1.762,1.762A1.762,1.762,0,0,0,325.87,406.438Z"
          transform="translate(-304.322 -362.065)"
          fill="#cfcce0"
        />
        <circle
          id="Ellipse_289"
          data-name="Ellipse 289"
          cx="1.908"
          cy="1.908"
          r="1.908"
          transform="translate(25.658 51.272)"
          fill="#cfcce0"
        />
        <path
          id="Path_639"
          data-name="Path 639"
          d="M341.549,506.738a2.055,2.055,0,1,1,2.055-2.055A2.055,2.055,0,0,1,341.549,506.738Zm0-3.817a1.762,1.762,0,1,0,1.762,1.762A1.762,1.762,0,0,0,341.549,502.921Z"
          transform="translate(-318.092 -446.805)"
          fill="#cfcce0"
        />
        <path
          id="Path_640"
          data-name="Path 640"
          d="M382.554,539.3a2.055,2.055,0,1,1,2.055-2.055A2.055,2.055,0,0,1,382.554,539.3Zm0-3.817a1.762,1.762,0,1,0,1.762,1.762A1.762,1.762,0,0,0,382.554,535.485Z"
          transform="translate(-354.107 -475.405)"
          fill="#cfcce0"
        />
        <circle
          id="Ellipse_290"
          data-name="Ellipse 290"
          cx="1.908"
          cy="1.908"
          r="1.908"
          transform="translate(20.08 66.099)"
          fill="#cfcce0"
        />
        <path
          id="Path_641"
          data-name="Path 641"
          d="M361.411,691.756s-1.908-4.7,3.817-8.221Z"
          transform="translate(-337.074 -605.693)"
          fill="#cfcce0"
        />
        <path
          id="Path_642"
          data-name="Path 642"
          d="M289.56,714.635s-.869-5-7.591-4.953Z"
          transform="translate(-267.57 -628.657)"
          fill="#cfcce0"
        />
        <path
          id="Path_648"
          data-name="Path 648"
          d="M554.43,187.413s-2.268-.81-3.726,2.43a63.869,63.869,0,0,1-3.725,6.8l1.3.324s.324-2.268,1.134-2.592l-.324,2.916s9.719,3.4,14.092-.324l-.162-1.134s.648.162.648,1.134l.486-.486a8.706,8.706,0,0,0-1.944-2.268,5.716,5.716,0,0,1-1.4-3.48,4.321,4.321,0,0,0-6.376-3.323Z"
          transform="translate(-500.323 -169.468)"
          fill="#2f2e41"
        />
        <path
          id="Path_649"
          data-name="Path 649"
          d="M535.58,141.059l-2.349-2.936L531.47,132.1l6.753-7.193s1.468-5.578.147-5.285-1.615,4.4-1.615,4.4l-8.514,6.606s.881,9.248,3.376,12.478l1.908,6.019Z"
          transform="translate(-483.865 -110.412)"
          fill="#ffb9b9"
        />
        <path
          id="Path_650"
          data-name="Path 650"
          d="M617.5,141.059l2.349-2.936,1.762-6.019-6.753-7.193s-1.468-5.578-.147-5.285,1.615,4.4,1.615,4.4l8.514,6.606s-.881,9.248-3.376,12.478l-1.908,6.019Z"
          transform="translate(-559.33 -110.412)"
          fill="#ffb9b9"
        />
        <circle
          id="Ellipse_292"
          data-name="Ellipse 292"
          cx="3.817"
          cy="3.817"
          r="3.817"
          transform="translate(51.128 20.518)"
          fill="#ffb9b9"
        />
        <path
          id="Path_651"
          data-name="Path 651"
          d="M590.044,260.815s.147,3.083-.734,4.11-1.761,6.312,2.5,6.459,3.817-4.4,3.817-4.4l-.881-2.5a5.27,5.27,0,0,1-.881-3.67Z"
          transform="translate(-536.861 -234.425)"
          fill="#ffb9b9"
        />
        <path
          id="Path_654"
          data-name="Path 654"
          d="M576.081,210.929a6.6,6.6,0,0,1,2.43-2.106c1.134-.324,1.3-1.944,1.3-1.944s2.916,3.24,4.7,3.4.162-3.888.162-3.888l-3.24-.81-3.078.324-2.43,1.62Z"
          transform="translate(-525.74 -185.916)"
          fill="#2f2e41"
        />
        <path
          id="Path_657"
          data-name="Path 657"
          d="M438.274,77.261h-1.408V75.853h-.128v1.408H435.33v.128h1.408V78.8h.128V77.389h1.408Z"
          transform="translate(-374.594 -66.62)"
          fill="#cfcce0"
        />
        <path
          id="Path_658"
          data-name="Path 658"
          d="M328.342,53.076h-1.408V51.668h-.128v1.408H325.4V53.2h1.408v1.408h.128V53.2h1.408Z"
          transform="translate(-278.042 -45.379)"
          fill="#cfcce0"
        />
        <path
          id="Path_659"
          data-name="Path 659"
          d="M381.109,1.408H379.7V0h-.128V1.408h-1.408v.128h1.408V2.944h.128V1.536h1.408Z"
          transform="translate(-324.387)"
          fill="#cfcce0"
        />
        <g
          id="Group_425"
          data-name="Group 425"
          transform="translate(26.342 85.326)"
        >
          <path
            id="Path_759"
            data-name="Path 759"
            d="M285.424,762.59c0,1.921-13,6.3-29.047,6.3s-29.047-4.377-29.047-6.3,13-.658,29.047-.658S285.424,760.669,285.424,762.59Z"
            transform="translate(-227.331 -759.112)"
            fill="#3f3d56"
          />
          <path
            id="Path_760"
            data-name="Path 760"
            d="M285.424,762.59c0,1.921-13,6.3-29.047,6.3s-29.047-4.377-29.047-6.3,13-.658,29.047-.658S285.424,760.669,285.424,762.59Z"
            transform="translate(-227.331 -759.112)"
            opacity="0.1"
          />
          <ellipse
            id="Ellipse_306"
            data-name="Ellipse 306"
            cx="29.047"
            cy="3.478"
            rx="29.047"
            ry="3.478"
            transform="translate(0)"
            fill="#3f3d56"
          />
        </g>
        <path
          id="Path_643"
          data-name="Path 643"
          d="M675.674,648.467H643.192s-.659-9.657,3.237-9.767,3.457,4.28,8.34-1.756,10.809-5.706,11.577-2.14-1.481,6.42,2.634,5.542S679.021,641.773,675.674,648.467Z"
          transform="translate(-584.326 -560.643)"
          fill="#89bf4d"
        />
        <path
          id="Path_644"
          data-name="Path 644"
          d="M771.632,648.06l-.11,0a33.445,33.445,0,0,1,2.659-12.75,11.574,11.574,0,0,1,2.3-3.529l.073.082a11.494,11.494,0,0,0-2.274,3.5A33.352,33.352,0,0,0,771.632,648.06Z"
          transform="translate(-697.536 -560.234)"
          fill="#f2f2f2"
        />
        <path
          id="Path_645"
          data-name="Path 645"
          d="M868.249,714l-.105-.031a17.023,17.023,0,0,1,4.286-7.13l.074.081A16.9,16.9,0,0,0,868.249,714Z"
          transform="translate(-782.397 -626.161)"
          fill="#f2f2f2"
        />
        <path
          id="Path_646"
          data-name="Path 646"
          d="M664.744,696.656l-.109-.015a11.951,11.951,0,0,0-1.075-6.986,9.616,9.616,0,0,0-1.7-2.476l.076-.079a9.744,9.744,0,0,1,1.719,2.506A12.061,12.061,0,0,1,664.744,696.656Z"
          transform="translate(-601.224 -608.824)"
          fill="#f2f2f2"
        />
        <path
          id="Path_647"
          data-name="Path 647"
          d="M654.631,619.9H614.237l-.009-.137c-.023-.34-.538-8.37,2.063-11.235a2.849,2.849,0,0,1,2.082-1,6.2,6.2,0,0,1,3.621,1.1c1.62.961,2.69,1.6,6.582-3.214,4.216-5.21,8.764-6.331,11.379-5.708a4.059,4.059,0,0,1,3.195,3.124,13.857,13.857,0,0,1,.137,4.037c-.088,1.21-.158,2.166.339,2.6.415.362,1.243.394,2.606.1,2.773-.591,6.642-.085,8.583,2.424,1.045,1.35,1.868,3.8-.144,7.827Zm-40.119-.294h39.937c1.5-3.042,1.546-5.611.134-7.435-1.781-2.3-5.519-2.907-8.29-2.316-1.481.316-2.364.264-2.86-.169-.608-.53-.533-1.55-.439-2.842a13.615,13.615,0,0,0-.131-3.954,3.775,3.775,0,0,0-2.976-2.9c-2.531-.6-6.953.5-11.083,5.607-4.051,5.007-5.271,4.283-6.96,3.281a5.887,5.887,0,0,0-3.463-1.056,2.567,2.567,0,0,0-1.873.9C614.169,611.3,614.455,618.524,614.512,619.61Z"
          transform="translate(-559.337 -531.932)"
          fill="#cfcce0"
        />
        <path
          id="Path_652"
          data-name="Path 652"
          d="M564.862,541.824l3.156.954s2.569-1.541,2.569-.073-.881,3.376-.587,4.7.881,4.551,0,4.551-2.642-5.725-2.642-5.725l-2.936-1.615Z"
          transform="translate(-515.643 -481.231)"
          fill="#ffb9b9"
        />
        <path
          id="Path_653"
          data-name="Path 653"
          d="M588.834,710.671l-1.174,4.551s-1.028,1.321,0,1.908a2.983,2.983,0,0,1,1.074,1.366,2.511,2.511,0,0,0,2.465,1.492.991.991,0,0,0,1.026-.755,1.182,1.182,0,0,0-.227-.925,7.93,7.93,0,0,1-1.328-2.425l.44-5.138Z"
          transform="translate(-535.651 -629.526)"
          fill="#ffb9b9"
        />
        <path
          id="Path_655"
          data-name="Path 655"
          d="M458.178,438.893l-.587,1.174s-14.239,4.551-13.065,8.808,7.78,3.083,7.78,3.083l7.34,1.321.734-3.229-5.138-1.321,8.808-3.229.294,14.973-1.174,10.716,2.936.294s3.23-9.835,2.789-13.946c0,0,5.431-16.735,2.349-19.23S458.178,438.893,458.178,438.893Z"
          transform="translate(-410.28 -389.455)"
          fill="#2f2e41"
        />
        <path
          id="Path_656"
          data-name="Path 656"
          d="M560.167,290.183l-2.291-2.768-1.551.711-1.615,5.138A5.456,5.456,0,0,0,555,298.4s.294,1.762-.147,2.2-.587,3.229-.587,3.229l-1.908,3.67s10.863,1.908,14.092-.734c0,0-1.695-6.248-.667-8.156s1.174-4.834,0-6.155a20.019,20.019,0,0,1-2.416-4.772l-.711-.455Z"
          transform="translate(-505.05 -257.626)"
          fill="#cfcce0"
        />
      </g>
    </svg>
  </section>
</template>

<script>
export default {
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>